import React from 'react';  
import { Link } from 'react-router-dom';  
import { ArrowLeft, Clock, Users, Award } from 'lucide-react';  
import { Badge } from '../ui/badge';  
import { Button } from '../ui/button';  
import { Progress } from '../ui/progress';  

interface CourseHeaderProps {  
  course: any;  
  onContinueLearning: () => void;  
}  

export const CourseHeader: React.FC<CourseHeaderProps> = ({   
  course,   
  onContinueLearning   
}) => {  
  return (  
    <div className="w-full space-y-8"> {/* Added w-full for full width */}  
      {/* Back button */}  
      <div>  
        <Link to="/courses" className="inline-flex items-center gap-2 text-gray-600 hover:text-primary transition-colors">  
          <ArrowLeft size={18} />  
          <span>Back to Courses</span>  
        </Link>  
      </div>  

      <div className="flex flex-col lg:flex-row gap-8 w-full"> {/* Added w-full for full width */}  
        <div className="lg:w-3/3 w-full"> {/* Keep lg:w-2/3 for large screens and w-full for small */}  
          <div className="rounded-xl overflow-hidden mb-6 shadow-sm border border-gray-200">  
            <img   
              src={course?.thumbnail?.url || course?.image}   
              alt={course?.title}   
              className="w-full aspect-video object-cover"  
            />  
          </div>  
          
          <div className="flex flex-wrap items-center gap-3 mb-4">  
            {course?.category && (  
              <Badge className="bg-primary hover:bg-primary">  
                {course.category}  
              </Badge>  
            )}  
            {course?.level && (  
              <Badge variant="outline" className="text-gray-600">  
                {course.level}  
              </Badge>  
            )}  
          </div>  
          
          <h1 className="text-3xl font-bold mb-4">{course?.title}</h1>  
          
          <div className="flex flex-wrap gap-4 text-sm text-gray-600 mb-6">  
            <div className="flex items-center gap-1">  
              <Clock size={16} className="text-primary" />  
              <span>{course?.duration || "120 hours"}</span>  
            </div>  
            <div className="flex items-center gap-1">  
              <Users size={16} className="text-primary" />  
              <span>{course?.students || 0} students enrolled</span>  
            </div>  
            <div className="flex items-center gap-1">  
              <Award size={16} className="text-primary" />  
              <span>Certificate on completion</span>  
            </div>  
          </div>  
          
          <div className="bg-white rounded-xl p-6 border border-gray-200 mb-6">  
            <h2 className="text-xl font-semibold mb-3">Course Description</h2>  
            <p className="text-gray-700 text-left">  
              {course?.courseDescription ?? course?.courseContent}  
            </p>  
          </div>  
          
          {/* <div className="flex items-center gap-4 mb-8">  
            <div className="flex-1">  
              <div className="flex justify-between text-sm mb-2">  
                <span className="font-medium">Course Progress</span>  
                <span>{course?.progress || 0}%</span>  
              </div>  
              <Progress value={course?.progress || 0} className="h-2" />  
            </div>  
            
            <Button   
              className="bg-primary hover:bg-primary/90"  
              onClick={onContinueLearning}  
            >  
              Continue Learning  
            </Button>  
          </div>   */}
        </div>  
      </div>  
    </div>  
  );  
};  